import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import LeftSide from "./LeftSide";

const Layout = () => {
  return (
    <div className="app">
      <LeftSide />
      <div className="main">
        <Outlet />
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
